
import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const GaugeChart = ({
  width = 550,
  height = 150,
  data = [],
  colors = ["#FFA500", "#B266FF"],
  valueKey = "value",
  labelKey = "label",
  showCenterValue = true,
}) => {
  const ref = useRef();

  useEffect(() => {
    const safeData =
      data.length > 0
        ? data.map((d) => ({ ...d, [valueKey]: d[valueKey] || 0 }))
        : [{ [labelKey]: "No Data", [valueKey]: 0 }];

    const radius = Math.min(width, height * 2) / 2;
    const innerRadius = radius * 0.7;
    const startAngle = -Math.PI;
    const endAngle = 0;

    const svg = d3
      .select(ref.current)
      .attr("width", width)
      .attr("height", height)
      .html("")
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height})`);

    const pie = d3
      .pie()
      .sort(null)
      .startAngle(startAngle)
      .endAngle(endAngle)
      .padAngle(0.03)
      .value((d) => d[valueKey]);

    const arc = d3
      .arc()
      .innerRadius(innerRadius)
      .outerRadius(radius)
      .cornerRadius(8);

    const colorScale = d3.scaleOrdinal().range(colors);

    // --- Tooltip Creation ---
    const tooltip = d3
      .select("body")
      .append("div")
      .attr(
        "class",
        "absolute text-xs px-2 py-1 rounded shadow bg-white border border-gray-300"
      )
      .style("display", "none");

    svg
      .selectAll("path")
      .data(pie(safeData))
      .enter()
      .append("path")
      .attr("d", arc)
      .attr("fill", (_, i) => colorScale(i))
      .attr("stroke", "#fff")
      .attr("stroke-width", 2)
      .on("mouseover", function (event, d) {
        tooltip
          .style("display", "block")
          .html(`${d.data[labelKey]}: <b>${d.data[valueKey]}</b>`);
      })
      .on("mousemove", function (event) {
        tooltip
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY - 20 + "px");
      })
      .on("mouseout", () => tooltip.style("display", "none"));

   if (showCenterValue) {
  const total = safeData.reduce((sum, d) => sum + d[valueKey], 0);
  svg
    .append("text")
    .attr("text-anchor", "middle")
    .attr("dy", "-0.5em")
    .attr("font-size", "24px")
    .attr("font-weight", "bold")
    .attr("transform", "rotate(-90)")  
    .attr("x", 0)
    .attr("y", 10)
    .text(total);
}
  }, [data, width, height]);

  return <svg ref={ref} className="overflow-visible rotate-90 mt-24" />;
};

export default GaugeChart;
